export default {
  title: 'Playground',
};
